
import { useState, createContext, useEffect } from 'react';

export const MobiOrNotContext = createContext();

export const MobiOrNotContextProvider = (props) => {
    const [mobiOrNot, setMobiOrNot] = useState(false);

    useEffect(() => {
        handleResizeMobi();
    }, []);

    const handleResizeMobi = () => {

        const isAndroid = /Android/i.test(navigator.userAgent);
        const isIpad = /iPad|IPad/i.test(navigator.userAgent);
        const isIphone = /iPhone/i.test(navigator.userAgent);

        const isTablet = isIpad || (isAndroid && !/Mobile/i.test(navigator.userAgent));

        if (isIpad) {
            setMobiOrNot(false);
        } else if (isIphone) {
            if ((window.innerWidth > window.innerHeight)) {

                setMobiOrNot(!(window.innerHeight >= 1024));
            }
            else {
                setMobiOrNot(true);
            }
        } else if (isAndroid) {
            if ((window.innerWidth > window.innerHeight)) {
                setMobiOrNot(!(window.innerHeight >= 1024));
            } else if (!isTablet) {
                setMobiOrNot(true);
            } else {
                setMobiOrNot(false);
            }
        } else if ((window.innerWidth <= window.innerHeight) &&
            (window.innerWidth <= 1024)
        ) {
            setMobiOrNot(true);
        } else {
            const isDesktop = !isTablet;

            if (isDesktop) {
                setMobiOrNot(false);
            } else {
                setMobiOrNot(true); // Assume non-recognized devices are mobile by default
            }
        }
    }

    useEffect(() => {
        window.addEventListener('resize', handleResizeMobi);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResizeMobi);
        };
    }, []); // Make sure to provide an empty dependency array to avoid adding multiple event listeners

    return (
        <MobiOrNotContext.Provider value={[mobiOrNot, setMobiOrNot]}>
            {props.children}
        </MobiOrNotContext.Provider>
    );
};
